const NAME = 'PLAN_SUBSCRIPTIONS_BULK_CREATE';

export const REQUEST_BULK_CREATE = `${NAME}/REQUEST_BULK_CREATE`;
export const REQUEST_BULK_CREATE_SUCCESS = `${NAME}/REQUEST_BULK_CREATE_SUCCESS`;
export const REQUEST_BULK_CREATE_FAILED = `${NAME}/REQUEST_BULK_CREATE_FAILED`;
